import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
	Avatar,
	Button,
	Checkbox,
	Container,
	CssBaseline,
	FormControlLabel,
	Grid,
	Input,
	InputAdornment,
	InputLabel,
	Link,
	LinearProgress,
	TextField,
	Typography,
} from '@mui/material';
import { Alert } from '@mui/material';
import { registerUser } from '../redux/ActionCreator';
import config from '../config.json';

import 'react-toastify/dist/ReactToastify.css';
const PREFIX = 'registration';

const classes = {
	avatar: `${PREFIX}-avatar`,
	paper: `${PREFIX}-paper`,
	submit: `${PREFIX}-submit`,
	form: `${PREFIX}-form`
};

const Root = styled('div')((
	{
		theme
	}
) => ({
	[`& .${classes.avatar}`]: {
		margin: theme.spacing(1),
		height: 50,
		backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
		width: 50,
		float: 'center',
		alignItems: 'center',
		textAlign: 'center'
	},

	[`& .${classes.paper}`]: {
		marginTop: theme.spacing(15),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		backgroundColor: '#ffffff',
		borderRadius: 20,
		zIndex: 5,

	},

	[`& .${classes.submit}`]: {
		margin: theme.spacing(3, 0, 2),
	},

	[`& .${classes.form}`]: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(3),
		float: 'center'
	}
}));

// import { fetchAttributeValues, KeyFillDropDown } from "../functions/helpers/general";
// import { handleFormChange } from '../functions/multiDropDown';

// toast.configure()



// Registration Part

export default function SignUp() {

	// const { type } = props.match.params
	// console.log(type);
	const { type } = useParams();
	const dispatch = useDispatch();
	const [passwordShown, setPasswordShown] = useState(false);
	const togglePassword = () => {
		// When the handler is invoked
		// inverse the boolean state of passwordShown
		setPasswordShown(!passwordShown);
	};
	const [isLoading, setisLoading] = useState(false)
	const [value, setValue] = React.useState('offer');
	const [state, setState] = React.useState({
		checkedA: true,
		checkedB: false,
	});
	const [submitHit, setSubmitHit] = useState(false);

	const initialFormData = Object.freeze({
		email_id: '',
		password: '',
		confirm_password: '',
		dob: "",
		first_name: '',
		last_name: '',
		mobile_number: '',
		address: '',
		org_name: '',
		linkedin_url: '',

	});

	const iformErrors = {
		first_name: '',
		last_name: '',
		password: '',
		dob: '',
		confirm_password: ''
	}

	const [formData, updateFormData] = useState(initialFormData);
	const [formErrors, updateFormErrors] = useState(iformErrors);
	const [errors, setErrors] = useState('');
	// const [communities, setCommunities] = useState([]);
	// const [organisations, setOrganisations] = useState([]);
	const disp = (false)

	const formValid = (formError) => {
		let valid = true;
		Object.values(formError).forEach(val => {
			val.length > 0 && (valid = false);
		})
		return valid;
	}

	const handleChange = (e) => {

		const { name, value } = e.target
		setState({ ...state, [e.target.name]: e.target.checked });
		updateFormData({
			...formData,
			// Trimming any whitespace
			[e.target.name]: e.target.value.trim(),
		});


		let formErr = formErrors;
		switch (name) {
			case 'first_name':
				formErr.first_name = (value.length === 0) ? "Please enter your first name" : "";
				break;
			case 'last_name':
				formErr.last_name = (value.length === 0) ? "Please enter your last name" : "";
				break;
			case 'password':
				formErr.password = (value.length < 6 && value.length > 0) ? "Minimum 6 characters" : "";
				break;
			default:
				break;
		}

		updateFormErrors(formErr)

	};

	useEffect(() => {
		setValue(type)
		// fetchAttributeValues({ setCommunities, setOrganisations, model: 'user' });
		// eslint-disable-next-line
	}, [])

	const handleSubmit = (e) => {
		e.preventDefault();
		setErrors('')
		setSubmitHit(true)
		if (formValid(formErrors)) {
			console.log('valid!')

			if (formData.dob === '') {
				console.log('wrong dob')
				return
			}

			const body = {
				first_name: formData.first_name,
				last_name: formData.last_name,
				dob: formData.dob,
				mobile_number: formData.mobile_number,
				email_id: formData.email_id.toLowerCase(),
				user_uuid: formData.first_name.toLowerCase().replace(/ /g, '_') + formData.last_name.charAt(0),
				password: formData.password,
				above_age: state.checkedA,
				account_type: value,
				address: formData.address,
				org_name: formData.org_name,
				linkedin_url: formData.linkedin_url,
				college: '',
				course: ''
			}

			setisLoading(true);
			dispatch(registerUser(body, setisLoading));


		} else {
			console.log('invalid!')
			setErrors('Please check whether information entered is correct.')
			return
		}
	}




	if (!isLoading) {
		return (
			<Root style={{ zIndex: 5 }}>

				<Container component="main" maxWidth='md'>
					<CssBaseline />
					<div className={classes.paper}>
						<Avatar className={classes.avatar}></Avatar>
						<div>
							<form className={classes.form} noValidate>
								<Grid container spacing={1} justifyContent='center' >
									<Grid container spacing={2} justifyContent='center' style={{ paddingTop: '2vh' }} >
										<Grid item xs={10} md={3} style={{ textAlign: 'center' }}>
											<InputLabel style={{ textAlign: 'left' }}>First Name</InputLabel>
											<Input
												variant="outlined"
												required={true}
												fullWidth
												name="first_name"
												label="First Name"
												type="FirstName"
												id="first_name"
												onChange={handleChange}
												error={submitHit && formData.first_name.length === 0}
											/>

										</Grid>
										<Grid item xs={10} md={3} style={{ textAlign: 'center' }}>
											<InputLabel style={{ textAlign: 'left' }}>Last Name</InputLabel>
											<Input
												variant="outlined"
												required={true}
												fullWidth
												name="last_name"
												label="Last Name"
												type="LastName"
												id="LastName"
												onChange={handleChange}
											/>

										</Grid>
									</Grid>
									<Grid container spacing={2} justifyContent='center' style={{ paddingTop: '2vh' }}>
										<Grid item xs={10} md={3}>
											<InputLabel style={{ textAlign: 'left' }}>Date of Birth</InputLabel>

											<TextField
												id="dob"
												name="dob"
												type="date"
												size="small"
												fullWidth
												variant="outlined"
												onChange={handleChange}
												placeholder="DD-MM-YYYY"
												inputProps={{
													maxLength: 10, // Limit the maximum number of characters to match the format
													pattern: '\\d{2}/\\d{2}/\\d{4}', // Use a regular expression pattern for validation
												}}
												InputLabelProps={{
													shrink: true,
												}}
												error={submitHit && formData.dob.length === 0}
											/>
										</Grid>
										<Grid item xs={10} md={3} style={{ textAlign: 'center' }} >

											<InputLabel style={{ textAlign: 'left' }}>Email Address</InputLabel>
											<Input
												variant="outlined"
												required
												fullWidth
												id="email_id"
												label="Email Address"
												name="email_id"
												autoComplete="email"
												onChange={handleChange}
												error={submitHit && formData.email_id.length === 0}
											/>
										</Grid>
									</Grid>
									<Grid container spacing={2} justifyContent='center' style={{ paddingTop: '2vh' }} >
										<Grid item xs={10} md={3} style={{ textAlign: 'center' }}>
											<InputLabel style={{ textAlign: 'left' }}> Mobile Number </InputLabel>
											<Input
												variant="outlined"
												required
												fullWidth
												name="mobile_number"
												label="Mobile Number(+91): "
												type="tel"
												id="MobileNo"

												onChange={handleChange}
											/>
										</Grid>


										<Grid item xs={10} md={3} style={{ textAlign: 'center' }}>
											<InputLabel style={{ textAlign: 'left' }}>Password</InputLabel>
											<Input

												required
												fullWidth
												style={{ height: 40 }}
												name="password"
												label="Password"
												error={submitHit && formData.password.length === 0}
												type={passwordShown ? "text" : "password"}
												id="password"
												autoComplete="current-password"
												onChange={handleChange}
												endAdornment={
													<InputAdornment position="end">
														<Button onClick={togglePassword}><span className="material-icons">
															visibility
														</span></Button>
													</InputAdornment>
												}
											/>
											{formErrors.password.length > 0 && (
												<Grid item style={{ textAlign: 'center', marginTop: 16 }}><span className=" ">{formErrors.password}</span></Grid>
											)}
										</Grid>
										{/* <Grid item xs={10} md={3} style={{ textAlign: 'center' }}>
											<InputLabel style={{ textAlign: 'left' }}>LinkedIn Profile URL </InputLabel>
											<Input
												variant="outlined"
												required
												fullWidth
												name="linkedin_url"
												label="LinkedIn"
												type="tel"
												id="linkedin_url"

												onChange={handleChange}
											/>
										</Grid> */}
									</Grid>
									{/* <Grid container spacing={2} justifyContent='center' style={{ paddingTop: '2vh' }} >
										<Grid item xs={10} md={3} style={{ textAlign: 'center' }}>
											<InputLabel style={{ textAlign: 'left' }}> Organisation Name </InputLabel>
											<KeyFillDropDown
												size="medium"
												options={organisations}
												keyName="org_name"
												formData={formData}
												updateFormData={updateFormData}
												handleFormChange={handleFormChange}
											/>
										</Grid>
										<Grid item xs={10} md={3} style={{ textAlign: 'center' }}>
											<InputLabel style={{ textAlign: 'left' }}> Community Name </InputLabel>
											<KeyFillDropDown
												size="medium"
												options={communities}
												keyName="community"
												formData={formData}
												updateFormData={updateFormData}
												handleFormChange={handleFormChange}
											/>
										</Grid>
									</Grid> */}
									<Grid item xs={10} md={12} style={{ textAlign: 'center' }} >
										<Typography style={{ marginTop: 8, marginBottom: 8, fontFamily: 'Raleway' }}> (If you're below 18, please provide your parent's email id and mobile number)</Typography>
									</Grid>
									<Grid item xs={6} md={12} style={{ textAlign: 'center' }}>
										{errors.length > 0 ? <Alert severity='error'> {errors}</Alert> : null}
									</Grid>

									<Grid item xs={12} md={12} style={{ textAlign: 'center', fontSize: 16 }}>
										<FormControlLabel
											control={<Checkbox checked={state.checkedB} onChange={handleChange} name="checkedB" style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />}

											style={{ marginTop: 8, color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }}
										/>I agree to the <a href='https://drive.google.com/file/d/1tlqy-e1LNcCIEORd-E0xFAeK_HzoWZLL/view?usp=sharing' target='_blank' rel='noopener noreferrer'>Terms and Conditions</a> and <a href='https://drive.google.com/file/d/1N3p9Wr2ksD61Cm1r9vjR0JCKGLRaLGSQ/view?usp=sharing' target='_blank' rel='noopener noreferrer'>Privacy Policy</a>
									</Grid>
									<Grid item xs={10} md={12} style={{ textAlign: 'center' }}>
										{state.checkedB ?
											<Button
												type="submit"
												variant="contained"
												color="primary"
												className={classes.submit}
												onClick={handleSubmit}
												style={{ height: 40, backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor, color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor }}
											>
												Sign Up
											</Button> :
											<Button
												type="submit"
												disabled
												variant="contained"

												className={classes.submit}
												onClick={handleSubmit}
												style={{ height: 40 }}
											>
												Sign Up
											</Button>}
									</Grid>
									<Grid item xs={10} md={12} style={{ textAlign: 'center' }}>
										<Link href="/login" variant="body2" style={{ marginTop: 31 }}>
											Already have an account? Sign in
										</Link>

									</Grid>
									{disp ? <h4>Please check your email to activate your account</h4> : ''}

								</Grid>
							</form>
						</div>
					</div>
				</Container>
			</Root>
		);
	} else {

		return (
			<div style={{ marginTop: 20, textAlign: 'center' }}>
				<img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
				<LinearProgress />

			</div>

		)

	}
}


